module.exports = __webpack_public_path__ + "static/img/14.13c72f91.jpg";